/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ShopRequest = {
    /**
     * Shop host URL (required when creating)
     */
    host?: string | null;
    /**
     * Shop UUID (optional for creation, required for update)
     */
    shopId?: string | null;
    /**
     * Shop type (required when creating)
     */
    shopType?: ShopRequest.shopType | null;
    /**
     * Shop settings as key-value pairs; omit to leave the stored settings untouched
     */
    settings?: Array<{
        key?: string;
        value?: string;
    }> | null;
    /**
     * Notification preferences of the calling user for this shop; replaces the stored set
     */
    notifications?: Array<{
        notification_type?: 'new_order' | 'site_down' | 'site_up' | 'sync_interval' | 'report_daily' | 'report_weekly' | 'report_monthly' | 'report_daily_time' | 'report_weekly_time' | 'report_monthly_time';
        /**
         * Boolean for toggles, seconds for sync_interval, "HH:MM" for report times
         */
        value?: any;
    }> | null;
    /**
     * Is shop enabled
     */
    isEnabled?: boolean | null;
    /**
     * Is shop online
     */
    isOnline?: boolean | null;
};
export namespace ShopRequest {
    /**
     * Shop type (required when creating)
     */
    export enum shopType {
        JTL_SHOP_5 = 'jtl_shop_5',
        JTL_WAWI_1_5 = 'jtl_wawi_1_5',
        JTL_WAWI_1_6 = 'jtl_wawi_1_6',
        EBAY_SHOP = 'ebay_shop',
        AMAZON_SHOP = 'amazon_shop',
        SHOPIFY_SHOP = 'shopify_shop',
    }
}

